var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.serviceCredential != null
    ? _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "700" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { dark: "" } },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("\n      View Service Credential\n    "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c("v-layout", [
                    _c("p", [
                      _vm._v(
                        " Copy the following three values into your Camunda process to authenticate with the service registry: "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md4: "", "offset-md1": "" } },
                        [
                          _c("ItemTextField", {
                            attrs: {
                              title: "ClientId",
                              value: _vm.serviceCredential.ClientId,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md4: "", "offset-md1": "" } },
                        [
                          _c("ItemTextField", {
                            attrs: {
                              title: "RefreshToken",
                              value: _vm.serviceCredential.RefreshToken,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-layout", { attrs: { wrap: "" } }, [
                    _c(
                      "p",
                      {
                        staticStyle: { margin: "0 auto", "margin-top": "10px" },
                      },
                      [_vm._v(" " + _vm._s(_vm.responseMessage) + " ")]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.setDialog(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }